import { render, staticRenderFns } from "./ajout-inventaire.html?vue&type=template&id=60a25d42&scoped=true&external"
import script from "./ajout-inventaire.js?vue&type=script&lang=js&external"
export * from "./ajout-inventaire.js?vue&type=script&lang=js&external"
import style0 from "./ajout-inventaire.scss?vue&type=style&index=0&id=60a25d42&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a25d42",
  null
  
)

export default component.exports